/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeMinusIcon20Light = forwardRef('SearchLoupeMinusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.256 9.504a7.248 7.248 0 1 1 12.714 4.76l3.376 3.375a.5.5 0 0 1-.708.707l-3.375-3.376A7.248 7.248 0 0 1 2.256 9.504Zm7.248-6.248a6.248 6.248 0 1 0 0 12.496 6.248 6.248 0 0 0 0-12.496Z" })));
});
